/*eslint-disable*/
import { reactive, ref, getCurrentInstance, toRaw ,onUnmounted, onMounted} from "vue";
import { onBeforeRouteLeave } from "vue-router";
import { SharedMap } from "fluid-framework";
import { AzureClient } from "@fluidframework/azure-client";
import api from "@/api";
import actToJsMind from "../api/jsmindlib/actionsToJsMind.js";
import main from "@/api/main";
var serverLocation = main.getServerLocation();

export function useMindMapFluidSync({ route, iviewMessage }) {
  let that = getCurrentInstance().proxy;
  let fluidMindHistory = reactive({});
  let fluidMindData = reactive({});
  let fluidIsDeleting = reactive({});
  let fluidCoworkMode = reactive({}); //fluid 也記錄目前協作模式，擁有者在使用者操作時改變協作模式，須通知其他使用者
  const hideDisconnetDialog = ref(false);

  let audience = reactive({});
  let fluidContainer = reactive({});
  const isInitReadingFluidData = ref(false);
  const currentCoworkMemberList = ref([]);
  const coworkLeader = ref("");
  const receviedHistoryChangeDuringInit = ref([]);
  const receviedNodeChangeDuringInit = ref([]);

 // 使用 vue-router 提供的 onBeforeRouteLeave
 onBeforeRouteLeave((to, from, next) => {
  hideDisconnetDialog.value = true;  
  if (fluidContainer && typeof fluidContainer.dispose === 'function') {
      fluidContainer.dispose();
    }
  fluidContainer = null;
  localStorage.removeItem("cachedFluidRelayToken");
  next(); // 允许导航
});
  onMounted(() => {
    window.addEventListener("beforeunload", disposeWhenSafe);
  });
  onUnmounted(() => {
    window.removeEventListener("beforeunload", disposeWhenSafe);
  });

  const testFluidShareMapInMind = async (containerId) => {
    that.$q.loading.show({
      message: that.$t("mindmap.initializeFluidRelay"),
    });
    //初始化先移除localStorage
    localStorage.removeItem("cachedFluidRelayToken"); //初始化先移除localStorage
    let container, services;

    const fluidConfig = await api.mindmapAPI.getFluidRelayConfig();
    let dataCenter = (serverLocation.includes("cn")) ? "china" : "global";
    // console.log(localStorage.getItem("id_token"),that.fromInfo.seat,that.fromInfo.name);
    isInitReadingFluidData.value = true;
    console.log(localStorage.getItem("id_token"),that.fromInfo.seat,that.fromInfo.name);
    try {
      const serviceConfig = {
        connection: {
          type: "remote",
          tenantId: fluidConfig[dataCenter]?.fluidRelayTenantId,
          tokenProvider: new api.MyAzTokenProvider(api.mindmapAPI.fluidTokenUrl, {
            idToken: localStorage.getItem("id_token")||"",
            id: that.fromInfo.seat,
            name: that.fromInfo.name==""?'anonymous':that.fromInfo.name,
          }),
              endpoint: fluidConfig[dataCenter]?.fluidRelayEndpoint,
        },
      };
      const client = new AzureClient(serviceConfig);

      const containerSchema = {
        initialObjects: {
          mindHistory: SharedMap,
          mindData: SharedMap,
          isDeleting: SharedMap,
          coworkMode: SharedMap,
        },
      };

      // 捕捉 getContainer 操作中的異常
      const result = await client.getContainer(containerId, containerSchema, "2");
      container = result.container;
      fluidContainer = container;
      services = result.services;

      console.log(client.getContainerVersions(containerId), "getContainerVersions");
    } catch (error) {
      console.error(error);
      iviewMessage.error(that.$t("mindmap.cannotConnect"));
      return; // 如果無法獲取容器，直接退出
    }

    fluidMindData = container.initialObjects.mindData; //存放markdown資料
    fluidMindHistory = container.initialObjects.mindHistory;
    fluidIsDeleting = container.initialObjects.isDeleting; //是否處於殺除狀態
    fluidCoworkMode = container.initialObjects.coworkMode; //協作模式
    audience = services.audience;

    //判斷被殺除 直接斷開
    if (fluidIsDeleting && fluidIsDeleting.get("data")) {
      if (route.name == "MindMap") {
        iviewMessage.warning({
          content: that.$t("mindmap.alreadyDeleted"),
          duration: 5,
        });
      }
      container.dispose();
      isDeleting.value = true;
      return;
    }
    fluidIsDeleting.on("valueChanged", () => {
      if (fluidIsDeleting.get("data")) {
        if (route.name == "MindMap") {
          iviewMessage.warning({
            content: that.$t("mindmap.alreadyDeleted"),
            duration: 5,
          });
        }
        container.dispose();
        isDeleting.value = true;
      }
    });

    
      fluidCoworkMode.on("valueChanged", (changed) => {
      if(that.isCreator) return 
      if (fluidCoworkMode.get("data")) {
        let fluidCoworkModeData = JSON.parse(fluidCoworkMode.get("data"));
        if (route.name == "MindMap"&&fluidCoworkModeData.openCowork!=that.currentMindMapInfo.openCowork||fluidCoworkModeData.coworkMode!=that.currentMindMapInfo.coworkMode) {
        
          
        iviewMessage.warning({
          content: "擁有者調整了使用權限，稍後將重整頁面",
          duration: 5,
        });
        window.location.reload();
        
        console.log("模式改變", JSON.parse(fluidCoworkMode.get("data"),that.currentMindMapInfo),fluidCoworkModeData,that.isCreator);
       
        // setTimeout(() => {
        //   window.location.reload();
        // }, 5000); // 5秒後重新整理頁面
        }
      }
      });
    

    const updateMindMap = async (changed) => {
      if (isInitReadingFluidData.value) {
        console.log("收到更新在初始化時!", changed);
        receviedHistoryChangeDuringInit.value.push(changed.key);
      } else {
        console.log("收到更新!", changed);
        // 调用更新方法
        await updateStageNodeByFluidKey(changed.key);
      }
    };



    const updateMindMapAll = async (changed) => {
      that.showNameLabel = false;
      const dont_center = true;
      if (that.isLoadingMD) {
        return;
      }
      if (isInitReadingFluidData.value) {
        receviedNodeChangeDuringInit.value.push(changed.key);
      } else {
        let value = fluidMindData.get(changed.key);
        if (value) {
          const item = JSON.parse(value).data;
          const finalAction = JSON.parse(value)?.data?.finalAction;
          //自己也要收更新因為是會去維護mind.data的結構, 靠jm 的api 似乎不會立即更新
          console.log("收到更新!", changed);
          updateStageNodeByNodeId(value, changed.key);
          sortMindDataNode(); //moveToTop/moveToBottom 時需要重新排序
          that.replaceNodeArrImgUrl(that.mind.data); //每次代換blobsas
          that.jm.show(that.mind, dont_center);
          let timeout = setTimeout(() => {
            that.jm.view.relayout();
            clearTimeout(timeout);
          }, 300);

          //顯示編輯者名牌標籤
          switch (finalAction) {
            case "add":
            case "update":
            case "copy":
              that.setCurrentNameLabel(item, changed.key);
              break;
          }
        } else {
          that.jm.enable_edit(); //啟用編輯
          const deleteNode = that.jm.get_node(changed.key);

          if (deleteNode) {
            that.jm.remove_node(changed.key);
            let deleteNodeId = changed.key;
            let deleteNodeIndex = toRaw(that.mind.data).findIndex((item) => item.id == deleteNodeId);
            if (deleteNodeIndex != -1) {
              that.mind.data.splice(deleteNodeIndex, 1);
            }
          }
        }
      }
    };

    // fluidMindHistory.on("valueChanged", updateMindMap);
    fluidMindData.on("valueChanged", updateMindMapAll);
    audience.on("membersChanged", updateMembers);

    let checkTimer; // 定时器引用

    const relayoutWithPromise = (timeout, force) => {
      return new Promise((resolve) => {
        that.relayout(timeout, force);
        // 如果 relayout 是异步的，延迟后解析 Promise
        setTimeout(() => resolve(), timeout + 500); // 增加缓冲时间，确保 relayout 执行完成
      });
    };
    const sortMindDataNode = () => {
      // 对节点进行排序：先按 parentid 排序，再按 index 排序
      that.mind.data.sort((a, b) => {
        // 如果 parentid 不同，按 parentid 字符串的字典顺序排序
        if (a.parentid !== b.parentid) {
          return (a.parentid || "").localeCompare(b.parentid || "");
        }
        // 如果 parentid 相同，按 index 升序排序
        return a.index - b.index;
      });
    };

    const updateStageNodeByNodeId = (value, key) => {
      let item = JSON.parse(value);
      let index = that.mind.data.findIndex((item) => item.id == key);
      let nodeData={}
      if(item?.parentid){ //在初始化時HTLocal傳來的node資料欄位可直接用
        nodeData = item
      }
      else{
        nodeData = {
          id: item.id,
          parentid: item.parent?.id,
          topic: item.topic,
          ...item.data,
          index: item.index,
          isroot: item.isroot,
          expanded: item.expanded,
          direction: item?.direction == -1 || item?.direction == "left" ? "left" : "right",
        };
      }
    
      
      if (index !== -1) {
        that.mind.data[index] = nodeData;
      } else {
        that.mind.data.push(nodeData);
      }
    };

    const updateStageNodeByFluidKey = async (key, index) => {
      const actionItem = fluidMindHistory.get(key);

      if (!actionItem) {
        console.error("ActionItem is undefined or null, cannot parse it");
        return;
      }

      let item;
      try {
        item = JSON.parse(actionItem);
      } catch (error) {
        console.error("Failed to parse actionItem as JSON:", actionItem);
        return;
      }

      if (item) {
        await that.updateStageNode(item, index); // 确保操作完成后返回
      }
    };

    const initReadFluidHistory = async () => {
      try {
        console.log("Start processing FluidMindHistory...");

        // 將 Map 轉為陣列進行排序
        const entries = Array.from(fluidMindHistory.entries());

        // 排序
        entries.sort((a, b) => {
          const numA = parseInt(a[0].split("-")[0], 10); // 轉換為數字
          const numB = parseInt(b[0].split("-")[0], 10);
          return numA - numB; // 升序排序
        });

        let index = 1; // 计数器，用于标记顺序
        for (const [key] of entries) {
          await updateStageNodeByFluidKey(key, index); // 等待完成后再处理下一个
          index++;
        }
        console.log("All FluidHistories put into stage successfully.");
      } catch (error) {
        console.error("An error occurred during histories processing:", error);
      }
    };

    const readChangeDuringInit = async () => {
      try {
        console.log("Start processing readChangeDuringInit:" + receviedHistoryChangeDuringInit.value);

        for (const item of receviedHistoryChangeDuringInit.value) {
          await updateStageNodeByFluidKey(item); // 等待完成后再处理下一个
        }
        console.log("All readChangeDuringInit put into stage successfully.");
        await relayoutWithPromise(2000, true);
      } catch (error) {
        console.error("An error occurred during  readChangeDuringInit processing:", error);
      }
    };

    const initReadFluidData = async () => {
      isInitReadingFluidData.value = true;
      if (!that.isLoadingMD) {
        clearTimeout(checkTimer); // 清除定时器

        await initReadFluidHistory(); //帶入history的數據
        that.hideNameLabel();

        console.log("完成載入History");

        that.replaceNodeImgUrl(that.mind.data);

        isInitReadingFluidData.value = false;
      } else {
        // 如果数据不存在，2秒后再检查一次
        checkTimer = setTimeout(initReadFluidData, 2000);
      }
    };

  

    container.on("connected", async () => {
      console.log("container 回報已經 connected!");
    });

    //偵測有中斷就請使用者重整一下
    container.on("disconnected", () => {
      if (route.name == "MindMap"&&!hideDisconnetDialog.value) {
        iviewMessage.error(that.$t("mindmap.disconnected"));
      }
    });

    container.on("disposed", () => {
      updateMembers(); //初步抓取名單
      console.log("container已呼叫斷開!");
    });

    updateMembers(); //初步抓取名單

    //型別轉換
    that.mind = that.jm.get_data("node_array");

    that.jm.show(toRaw(that.mind));

    for (const [key, value] of fluidMindData) {
      updateStageNodeByNodeId(value, key);
    }

    console.warn("完成加入節點初始值");
    isInitReadingFluidData.value = false;
    for (const key of receviedNodeChangeDuringInit.value) {
      // console.log(key);
      let value = fluidMindData.get(key);
      if (value) {
        updateStageNodeByNodeId(value, key);
      }
      console.warn("更新初始化中收到節點(值的變動)");
    }

    that.replaceNodeArrImgUrl(that.mind.data);
    sortMindDataNode();

    console.warn("完成初始化的節點排序", toRaw(that.mind.data));
   
    that.jm.show(that.mind);
    await relayoutWithPromise(1500, true);
    that.hideNameLabel();

    console.log(Array.from(fluidMindData.entries()), "所有節點資料");
    console.log(calculateMapSizeInKB(fluidMindData), "KB，所有節點資料大小");
  };
  const updateMembers = () => {
    let members = audience.getMembers();
    // 先把 members 按 key 排序
    const sortedMembers = new Map([...members.entries()].sort((a, b) => a[0].localeCompare(b[0])));

    currentCoworkMemberList.value = Array.from(sortedMembers, ([key, value], index) => ({
      color: that.randomColor(),
      key,
      value,
      index, // 為每個元素加上從 0 開始的索引
    }));
    coworkLeader.value = currentCoworkMemberList.value?.[0];
    // console.log(audience.getMyself() ,"audience.getMyself()","611")
  };
  const directDispose = () => { 
    if (fluidContainer) {
      if (fluidContainer && typeof fluidContainer.dispose === 'function') {
        fluidContainer.dispose();
    }
      hideDisconnetDialog.value = true;
      console.log("呼叫主動斷開!");
    }
  };

  const  disposeWhenSafe = () => {
    if (audience && typeof audience.off === "function") {
      audience.off("membersChanged", updateMembers);
    }
    if (fluidContainer.isDirty) {
      fluidContainer.once("saved", () => {
        console.log("呼叫主動斷開!");
        if (fluidContainer && typeof fluidContainer.dispose === 'function') {
          fluidContainer.dispose();
      }
        fluidContainer = null;
        localStorage.removeItem("cachedFluidRelayToken");
      });
    }
  };
  const calculateMapSizeInKB = (map) => {
    // 将 Map 转换为 JSON 字符串
    const jsonString = JSON.stringify(Object.fromEntries(map));

    // 计算字节长度
    const byteSize = new Blob([jsonString]).size; // 或 Buffer.byteLength(jsonString, 'utf8') 在 Node.js 中使用

    // 转换为 KB
    return byteSize / 1024;
  };
  const setFluidCoworkMode=(data)=>{
    if(fluidCoworkMode){
      fluidCoworkMode.set("data",data);
    }
  }

  const setFluidMindHistory = (action, item, actionType = " ") => {
    return;
    if (fluidMindHistory) {
      console.log(item, "action");
      const id = Date.now() + "-" + that.genUUID(); // 加時間排序，後續可能會用到排序，避免多用戶重複

      const finalItem = JSON.stringify({
        from: that.fromInfo.seat,
        uuid: item.nodeID,
        action: action,
        actionType: actionType,
        item: JSON.stringify(item),
      });

      // 计算 finalItem 字符串的字节数
      const byteSize = new TextEncoder().encode(finalItem).length;

      // 将字节数转换为 KB (千字节)
      const sizeInKB = byteSize;

      console.log(`Size of finalItem: ${sizeInKB} byteSize`);

      try {
        // 嘗試第一次發送
        fluidMindHistory.set(id, finalItem);
      } catch (r) {
        // 重發一次
        try {
          const idRetry = Date.now() + "-" + that.genUUID(); // 重新生成ID
          fluidMindHistory.set(idRetry, finalItem); // 再次嘗試發送
        } catch (retryError) {
          if (route.name == "MindMap") {
            iviewMessage.error(that.$t("mindmap.cannotConnect"));
          }
        }
      }
    }
  };
  const safeStringify = (obj) => {
    //遇到循环引用时会无限递归，最终抛出 TypeError。安全序列化（跳过循环引用
    const visited = new WeakSet();

    return JSON.stringify(obj, (key, value) => {
      if (typeof value === "object" && value !== null) {
        if (visited.has(value)) {
          return; // 跳过循环引用
        }
        visited.add(value);
      }
      return value;
    });
  };

  const setFluidMindNodeData = (node) => {
    if (fluidMindData) {
      // 將節點轉換為安全的JSON格式
      let finalItem = JSON.parse(safeStringify(node));
      // 刪除不需要的屬性
      delete finalItem.children; // 刪除 children 屬性
      delete finalItem._data; // 刪除 _data 屬性

      // 如果節點的 finalAction 是 'delete'，則刪除該節點
      if (node?.finalAction === "delete") {
        fluidMindData.delete(node.nodeID); // 從 fluidMindData 中刪除該節點
        console.log("Fluid: delete node", node.nodeID);
        return; // 結束函數
      }

      //減少無用的資料
      if (finalItem?.parent) {
        finalItem.parent = {
          id: finalItem.parent?.id,
        };
      }
      finalItem.data.fromInfo = that.fromInfo;
      
      // 保留原有的 finalEditor，如果節點資料中有 finalEditor 就使用它
      if (node?.data?.finalEditor) {
        finalItem.data.finalEditor = node.data.finalEditor;
      }

      // 新增或更新節點
      try {
        fluidMindData.set(node.id, JSON.stringify(finalItem)); // 將節點添加到 fluidMindData 中
        console.log("Fluid:set node", finalItem); // 輸出當前的 fluidMindData
      } catch (r) {
        console.error(r, "r"); // 輸出錯誤信息
        // 如果發生錯誤，重試一次
        try {
          fluidMindData.set(node.id, JSON.stringify(finalItem)); // 再次嘗試添加節點
        } catch (retryError) {
          iviewMessage.error(that.$t("mindmap.disconnected")); // 顯示錯誤信息
        }
      }
    }
  };

  const clearFluidMindNodeData = () => {
    if (fluidMindData) {
      fluidMindData.clear();
    }
  };

  return {
    fluidContainer,
    isInitReadingFluidData,
    fluidMindHistory,
    fluidMindData,
    fluidIsDeleting,
    fluidCoworkMode,
    currentCoworkMemberList,
    coworkLeader,
    setFluidMindHistory,
    setFluidMindNodeData,
    setFluidCoworkMode,
    clearFluidMindNodeData,
    testFluidShareMapInMind,
    directDispose
  };
}

// await initReadFluidData();
// await readChangeDuringInit();

// // 將 Map 轉為陣列進行排序
// const entries2 = Array.from(fluidMindHistory.entries());

// // 排序
// let final=entries2.sort((a, b) => {
//   const numA = parseInt(a[0].split('-')[0], 10); // 轉換為數字
//   const numB = parseInt(b[0].split('-')[0], 10);
//   return numA - numB; // 升序排序
// });
// that.$q.loading.show({
//   message: '初始化容器2次轉換中，請稍後 ~'
// });
// that.mind = {
//   meta: { name: "jsMind-demo-tree", author: "", version: "" },
//   format: "node_tree",
//   data: {
//     id: "root",
//     topic: "<p>root</p>",
//     nodeText: "root",
//     nodeImg: "",
//     nodeLink: "",
//     expanded: true,
//     lock: false,
//     isroot: true,
//     children: [
//       {
//         id: "uuid1",
//         isroot: false,
//         topic: "<p>node1</p>",
//         nodeText: "node1",
//         nodeImg: "",
//         nodeLink: "",
//         expanded: true,
//         direction: "left",
//         lineColor: "red",
//         "background-color": "rgb(255, 238, 139)",
//         lock: false,
//       },
//       {
//         id: "uuid2",
//         isroot: false,
//         topic: "<p>node2</p>",
//         nodeText: "node2",
//         nodeImg: "",
//         nodeLink: "",
//         expanded: true,
//         direction: "left",
//         lineColor: "red",
//         "background-color": "rgb(255, 238, 139)",
//         lock: false,
//       },
//       {
//         id: "uuid3",
//         isroot: false,
//         topic: "<p>node3</p>",
//         nodeText: "node3",
//         nodeImg: "",
//         nodeLink: "",
//         expanded: true,
//         direction: "right",
//         lineColor: "red",
//         "background-color": "rgb(255, 238, 139)",
//         lock: false,
//       },
//       {
//         id: "uuid4",
//         topic: "<p>node4</p>",
//         nodeText: "node4",
//         nodeImg: "",
//         nodeLink: "",
//         expanded: true,
//         direction: "right",
//         lineColor: "red",
//         "background-color": "rgb(255, 238, 139)",
//         lock: false,
//       },
//     ],
//   },
// },
// that.jm.show(that.mind);
// setTimeout(() => {
//   let finalData = actToJsMind.actToMind(that.mind.data, final);
//   that.mind.data = finalData;
//   that.replaceNodeImgUrl(that.mind.data);
//   console.log(that.mind, "final");
//   that.jm.show(that.mind);
//   that.$q.loading.hide();
//   that.relayout();

//   console.log(that.jm.get_data("node_tree"), "final2");
// }, 500);

// const versions = await client.getContainerVersions(containerId);
// // 获取当前的本地时区
// const localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

// // 准备最新的快照日期
// const latestVersion = versions[0];
// const latestSnapshotDate = new Date(latestVersion.date);

// // 获取当前的时间并使用本地时区转换te(latestSnapshotDate.toLocaleString("en-US", { timeZone: localTimeZone }));
// iviewMessage.info({
//   content: `獲取最新同步數據快照版本為:&nbsp;&nbsp;<strong>${localSnapshotDate}</strong><br>如你在3分鐘內有做更新，遠端儲存的數據會有延遲，可能不是最新的，等待1-2分鐘再重整 !`,
//   duration: 20,
//   closable: true
// })
